import React, { Component } from "react";
import * as d3 from "d3";
import styled from "styled-components";
import { connect } from "react-redux";
import { beeswarm } from "d3-beeswarm";

const GraphContainer = styled.div`
  text-align: right;
  height: 90%;
  width: 75%;
  margin: auto;

  text {
    fill: ${props => props.theme.text};
    font-size: 12px;
    opacity: 0.5;
  }
  .y-axis line,
  .y-axis path {
    fill: none;
    stroke: #1b567a;
    stroke-width: 1px;
    stroke-dasharray: 1.5 2;
  }

  .y-axis text {
    font-size: 10px;
    opacity: 1;
    margin-right: 5px;
  }

  .nodes circle {
    fill: transparent;
    stroke: #545fea;
    stroke-width: 2px;
    cursor: pointer;

    &:hover {
      fill: #545fea;
    }
  }

  @media (min-width: 1800px) {
    height: 95%;
    text {
      font-size: 16px;
    }
    .y-axis text {
      font-size: 14px;
      margin-right: 10px;
    }

    .y-axis line,
    .y-axis path {
      stroke-dasharray: 2.55 3.39;
    }
  }

  @media (max-width: 575px) {
    visibility: hidden;
  }
`;

class PercentileBubbleGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        { id: 1, name: "a", value: 74, selected: false },
        { id: 2, name: "b", value: 66, selected: false },
        { id: 3, name: "c", value: 54, selected: false },
        { id: 4, name: "d", value: 44, selected: false },
        { id: 5, name: "e", value: 34, selected: false },
        { id: 6, name: "f", value: 24, selected: false },
        { id: 7, name: "g", value: 43, selected: false },
        { id: 8, name: "h", value: 5, selected: false },
        { id: 9, name: "i", value: 94, selected: true },
        { id: 10, name: "j", value: 84, selected: false },
        { id: 11, name: "k", value: 90, selected: false },
        { id: 12, name: "l", value: 95, selected: false },
        { id: 13, name: "m", value: 40, selected: false },
        { id: 14, name: "n", value: 66, selected: false },
        { id: 15, name: "o", value: 85, selected: false },
        { id: 16, name: "p", value: 56, selected: false },
        { id: 17, name: "q", value: 69, selected: false }
      ]
    };
  }

  componentDidMount() {
    this.drawGraph(this.handleCircleClick);
  }

  componentDidUpdate(prevProps) {
    this.drawGraph(this.handleCircleClick);
  }

  handleCircleClick = id => {
    console.log(id);

    let { data } = this.state;

    let itemIndex = data.findIndex(item => item.id === id);

    data[itemIndex].selected = !data[itemIndex].selected;

    this.setState({
      data
    });
  };

  drawGraph = handleCircleClick => {
    let { data } = this.state;

    var container = d3.select(this.graph);

    let containerWidth = container.node().getBoundingClientRect().width,
      containerHeight = container.node().getBoundingClientRect().height;

    var margin = { top: 10, right: 15, bottom: 10, left: 10 },
      width = containerWidth - margin.left - margin.right,
      height = containerHeight - margin.top - margin.bottom,
      circleMargin = 7,
      tickSize = 80;

    // For Screenwidth > 1800px
    if (window.innerWidth > 1800) {
      circleMargin = 9;
      tickSize = 120;
    }

    //Remove Previous
    container.select("svg").remove();

    var svg = container
      .append("svg")
      .attr("width", width + margin.right + margin.left)
      .attr("height", height + margin.top + margin.bottom);

    var y = d3
      .scaleLinear()
      .range([height, 0])
      .domain([0, 100]);

    let graphData = beeswarm()
      .data(data)
      .distributeOn(function(d) {
        return y(d.value);
      })
      .radius(circleMargin)
      .orientation("vertical")
      .side("negative")
      .arrange();

    var g = svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
      .attr("class", "vertical-bubble-graph");

    g.append("text")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("transform", `translate(${width},${height / 2}) rotate(90)`)
      .text("المؤشر المئوي لمستوى الجهة المختارة");

    g.append("g")
      .attr("class", "y-axis")
      .attr("transform", "translate(" + (width - 20) + ",0)")
      .call(
        d3
          .axisLeft(y)
          .ticks(5)
          .tickSize(tickSize)
          .tickFormat(d => d + "%")
      );

    let nodes = g.append("g").attr("class", "nodes");

    nodes
      .selectAll("circle")
      .data(graphData)
      .enter()
      .append("circle")
      .attr("r", 5)
      .attr("cx", function(d) {
        return width + d.x - 35;
      })
      .attr("cy", function(d) {
        return d.y;
      })
      .style("fill", function(d) {
        if (d.datum.selected == true) {
          return "#545fea";
        } else return "transparent";
      })
      .on("click", function(d) {
        handleCircleClick(d.datum.id);
      });
  };

  render() {
    return <GraphContainer ref={el => (this.graph = el)} />;
  }
}
const mapStateToProps = state => ({
  theme: state.themes.theme
});

export default connect(
  mapStateToProps,
  null
)(PercentileBubbleGraph);
